@if(dataVisible$) {
  <form [formGroup]="formGroup">
    <div formGroupName="box1">
      <div class="row">
        <div class="col col-1 pt-3">
          <p>Inkomen box 1</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150'"
                                            formControlName="belastbaarInkomen"
                                            label="Belastbaar inkomen"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="inkomstenbelasting"
                                            label="Belasting"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    </div>

    <div formGroupName="box2">
      <div class="row">
        <div class="col col-1">
          <p>Inkomen box 2</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="belastbaarInkomen"
                                            id="belastbaarInkomenbox2"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="inkomstenbelasting"
                                            id="inkomstenbelasting"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    </div>

    <div formGroupName="box3">
      <div class="row">
        <div class="col col-1">
          <p>Inkomen box 3</p>
        </div>
        <div class="col-2">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="belastbaarInkomen"
                                            id="belastbaarInkomenbox3"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="inkomstenbelasting"
                                            id="inkomstenbelastingbox3"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    </div>

    <div class="row">
      <div class="col col-1">
        <b>Verzamelinkomen</b>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="verzamelinkomen"
                                          id="verzamelinkomen"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3">

      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>

      <div class="row">
          <div class="col col-1">
             Premie volksverzekeringen
          </div>
          <div class="col-2"></div>
          <div class="col-3">
              <snelstart-ui-number-form-control [decimals]="0"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="premieVolksverzekeringen"
                                                id="premieVolksverzekeringen"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
          </div>
          <div class="col-3"></div>
          <div class="col-4"></div>
      </div>

    <div class="pt-3">
      <div class="row">
        <div class="col col-1">
          <p>Gecombineerde inkomensheffing</p>
        </div>
        <div class="col-2">
          <snelstart-venture-fiscaal-feature-spec-belasting-box1
            [inkomenBox1]="formGroup.controls.box1.controls.belastbaarInkomen.value ?? 0"
            [inkomenBox2]="formGroup.controls.box2.controls.belastbaarInkomen.value ?? 0"
            [inkomenBox3]="formGroup.controls.box3.controls.belastbaarInkomen.value ?? 0"
            [premieVV]="formGroup.controls.premieVolksverzekeringen.value ?? 0"
            [belastingBox1]="formGroup.controls.box1.controls.inkomstenbelasting.value ?? 0"
            [belastingBox2]="formGroup.controls.box2.controls.inkomstenbelasting.value ?? 0"
            [belastingBox3]="formGroup.controls.box3.controls.inkomstenbelasting.value ?? 0"
          >
          </snelstart-venture-fiscaal-feature-spec-belasting-box1>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="gecombineerdeInkomensheffing"
                                            id="gecombineerdeInkomensheffing"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    </div>

    <div formGroupName="heffingskortingen">
      <div class="row">
        <div class="col col-1 ">
          <p>Af: Heffingskortingen</p>
        </div>
        <div class="col-4">
          <snelstart-venture-fiscaal-feature-berekeningen-heffingskortingen
            [formGroup]="formGroup.controls.heffingskortingen">
          </snelstart-venture-fiscaal-feature-berekeningen-heffingskortingen>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="totaal"
                                            id="totaal"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    </div>

    @if((formGroup.controls.verrekendeBelastingKortingBox2.value ?? 0) !== 0) {
      <div class="row">
        <div class="col col-1 ">
          <p>Af: Belastingkorting box 2</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="verrekendeBelastingKortingBox2"
                                            id="verrekendeBelastingKortingBox2"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((formGroup.controls.alBetaaldeLoonbelasting.value ?? 0) !== 0) {
      <div class="row">
        <div class="col col-1 ">
          <p>Af: Ingehouden loonheffing</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="alBetaaldeLoonbelasting"
                                            id="alBetaaldeLoonbelasting"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((formGroup.controls.alBetaaldeDividendbelasting.value ?? 0) !== 0) {
      <div class="row">
        <div class="col col-1 ">
          <p>Af: Ingehouden dividendbelasting</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="alBetaaldeDividendbelasting"
                                            id="alBetaaldeDividendbelasting"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((formGroup.controls.voorlopigeAanslag.value ?? 0) < 0) {
      <div class="row">
        <div class="col col-1 ">
          <p>Bij: Ontvangen via voorlopige aanslag(en)</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="voorlopigeAanslag"
                                            prefix="€"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((formGroup.controls.voorlopigeAanslag.value ?? 0) > 0) {
      <div class="row">
        <div class="col col-1 ">
          <p>Af: Betaald op voorlopige aanslag(en)</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="voorlopigeAanslag"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    @if((formGroup.controls.aanslaggrens.value ?? 0) !== 0) {
      <div class="row">
        <div class="col col-1 ">
          <p>Af: Aanslaggrens</p>
        </div>
        <div class="col-2"></div>
        <div class="col-3">
          <snelstart-ui-number-form-control [decimals]="0"
                                            align="right"
                                            class="custom-input-150"
                                            formControlName="aanslaggrens"
                                            prefix="€ -"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-3"></div>
        <div class="col-4"></div>
      </div>
    }

    <div class="row">
      <div class="col col-1">
        @if((formGroup.controls.verschuldigdeInkomstenbelasting.value ?? 0) < 0) {
          <p><b>Te ontvangen inkomstenbelasting {{ isPartnerView ? 'partner' : 'aangever' }}</b></p>
        } @else {
          <p><b>Te betalen inkomstenbelasting {{ isPartnerView ? 'partner' : 'aangever' }}</b></p>
        }
      </div>
      <div class="col-2"></div>
      <div class="col-3">
        <snelstart-ui-number-form-control [decimals]="0"
                                          align="right"
                                          class="custom-input-150"
                                          formControlName="verschuldigdeInkomstenbelasting"
                                          id="verschuldigdeInkomstenbelasting"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
      <div class="col-3"></div>
      <div class="col-4"></div>
    </div>
  </form>
}
